import { CheckboxField, TextField } from "components/RenderInput"
import React from "react"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field } from "redux-form"

const PricingTab = () => {
  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>PRICING</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col xs="auto" className="mt-2">
              <Field
                component={CheckboxField}
                name="displayPrice"
                label="Display Price:"
              />
            </Col>
            <Col xs="auto" className="d-flex flex-wrap">
              <Field name="price" component={TextField} type="number" min="0" />
              <span className="mt-2">(zero for free)</span>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default PricingTab
